import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES, type AppLocale, normalizeLocale } from './constants.js';
import { setAppLocale } from './i18n.js';

export interface LocaleOption {
  value: AppLocale;
  label: string;
}

export function useLocale(): {
  locale: AppLocale;
  options: LocaleOption[];
  setLocale: (locale: AppLocale) => void;
} {
  const { i18n, t } = useTranslation('common');
  const locale = normalizeLocale(i18n.language);
  const options = useMemo<LocaleOption[]>(
    () => [
      { value: 'ru', label: t('locales.ru') },
      { value: 'en', label: t('locales.en') },
      { value: 'zh-Hans', label: t('locales.zhHans') },
    ],
    [t],
  );
  const setLocale = useCallback((next: AppLocale) => {
    void setAppLocale(next);
  }, []);
  return { locale, options, setLocale };
}

export { SUPPORTED_LOCALES };
